import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import "./app.css";
import { Myinput, Mylogo } from "../Useful/Useful";
import Raeenlogo from "../../img/maloos-logo.png";
import web from "../../img/web.jpg";
import { Button, Form } from "reactstrap";
import "react-awesome-slider/dist/styles.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Login } from "../../fetch";
import { useHistory } from "react-router-dom";

//slider
export class Myslider extends React.Component {
  render() {
    return (
      <div id="demo" class="carousel slide" data-ride="carousel">
        {/* <!-- Indicators --> */}
        <ul class="carousel-indicators">
          <li data-target="#demo" data-slide-to="0" class="active"></li>
          <li data-target="#demo" data-slide-to="1"></li>
          <li data-target="#demo" data-slide-to="2"></li>
        </ul>

        {/* <!-- The slideshow --> */}
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src={Raeenlogo} alt="Los Angeles" width="300" />
          </div>
          <div class="carousel-item">
            <img src={Raeenlogo} alt="Chicago" width="300" />
          </div>
          <div class="carousel-item">
            <img src={Raeenlogo} alt="New York" width="300" />
          </div>
        </div>

        {/* <!-- Left and right controls --> */}
        <a class="carousel-control-prev" href="#demo" data-slide="prev">
          <span
            class="carousel-control-prev-icon"
            style={{ color: "red", backgroundColor: "red" }}
          ></span>
        </a>
        <a class="carousel-control-next" href="#demo" data-slide="next">
          <span
            class="carousel-control-next-icon"
            style={{ color: "red", backgroundColor: "red" }}
          ></span>
        </a>
      </div>
    );
  }
}

export default function LoginMain(props) {
  const history = useHistory();

  function handleSubmit(e) {
    e.preventDefault();
    if (e.target.phoneNumber.value === "" || e.target.password.value === "") {
      toast.error("نام کاربری یا کلمه عبور وارد نشده است");
      return false;
    }

    Login({
      UserName: e.target.phoneNumber.value,
      Password: e.target.password.value,
      LoginType: "2",
    })
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        console.log();
        if (responseJson.success === true) {
          // if (
          //   responseJson.result.roleId == "a87bfaac-b749-4594-fc9a-08d847e1dc93"
          // ) {
          sessionStorage.setItem(
            "province",
            JSON.stringify(responseJson.result.provinces)
          );
          sessionStorage.setItem(
            "user",
            JSON.stringify(responseJson.tokenresult)
          );

          history.push("/main");
          window.location.reload();
          //   } else {
          //     toast.error("شما مجاز به ورود نیستید");
          //   }
          // } else {
          //   toast.error(responseJson.message);
        } else {
          toast.error(responseJson.message);
        }

        // : toast.error("خطای ارتباط با سرور");

        // if (!responseJson.success) {
        //   alert(responseJson.message);
        //   return false;
        // } else {
        //   localStorage.setItem("apiKey", responseJson.tokenresult);
        //   props.history.push('/MailListItem');
        //   return true;
        // }
      })
      .catch((error) => {
        console.log(error);
        toast.error("خطای ارتباط با سرور");
        return false;
      });
  }

  return (
    <div class="col-12 backLogin">
      <div class="row">
        <div class="col-lg-3"></div>
        <div class="col-lg-6 col-md-8 col-sm-12 col-xs-12 menuLogin shadow ">
          <div class="row">
            <div class="col-lg-6">
              <Myslider />
            </div>
            <div class="col-lg-6 my-5 ">
              <Form onSubmit={handleSubmit}>
                <Mylogo class="logoSize" src={Raeenlogo} alt="logo" />
                <h5>ورود به حساب کاربری</h5>

                <Myinput
                  id="phoneNumber"
                  name="نام کاربری "
                  type="text"
                  placeholder="نام کاربری ..."
                />
                <Myinput
                  name="کلمه عبور"
                  id="password"
                  type="password"
                  placeholder="کلمه عبور..."
                />
                <div className="my-2 d-flex justify-content-between">
                  <div>
                    <Button
                      color="primary"
                      size="sm"
                      id="loginidbtn"
                      type="submit"
                    >
                      ورود
                    </Button>
                  </div>
                  <div>
                    <span className="mr-4">
                      {" "}
                      <Link to="/forgetpass">فراموشی رمز عبور </Link>
                    </span>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
        <div class="col-lg-3"></div>
      </div>
    </div>
  );
}
